<template>
    <div class="w-full h-full fixed pt-[10px] bottom-0 z-[999] bg-[#FFF]">
        <div v-if="alertFreePlace" @click="closeView" class=" backdrop-blur-md fixed w-full z-[999] h-full"></div>
        <div v-if="alertFreePlace" class="w-[80%] px-[20px] h-[150px] bg-white rounded-md fixed top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] z-[999]">
            <div class="text-gray-emb font-bold text-[12px] text-center mt-[20px]">Якщо на це тренування звільниться місце, ми одразу повідомимо вас — і ви зможете забронювати його першими! 🌸</div>
            <button @click="alertFreePlace = false" class="rounded-md w-full text-gray-emb bg-green-emb mt-[10px] font-bold">Підтвердити</button>
            <button @click="alertFreePlace = false" class="rounded-md w-full text-gray-emb bg-rose-emb mt-[10px] font-bold">Скасувати</button>
        </div>

        <div v-if="bookTrainingFlag" @click="() => { bookTrainingFlag = false; trainingForBook = null }" class=" backdrop-blur-md fixed w-full z-[999] h-full"></div>
        <div v-if="bookTrainingFlag" class="w-[80%] px-[20px] pb-[20px] bg-white rounded-md fixed top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] z-[999]">
            <div v-if="currentTarriff?.tarrif_group_name == trainingForBook.tariff_group_name" class="text-gray-emb font-bold text-[12px] text-center mt-[20px]">Ви підтверджуєте запис на заняття {{ translateGroupName(trainingForBook.tariff_group_name) }}, {{ trainings[0]?.date.split('T')[0].split('-').reverse().join('.') }}, {{ trainingForBook.start_time }}?</div>
            <div v-if="currentTarriff?.tarrif_group_name != trainingForBook.tariff_group_name" class="text-gray-emb font-bold text-[12px] text-center mt-[20px]">Бажаєте дане тренування  {{ translateGroupName(trainingForBook.tariff_group_name) }}, {{ trainings[0]?.date.split('T')[0].split('-').reverse().join('.') }}, {{ trainingForBook.start_time }} списати з Вашого діючого абонементу, чи оплатити його, купивши абонемент з переліку нижче?</div>
            <button v-if="currentTarriff?.tarrif_group_name != trainingForBook.tariff_group_name" @click="addClientBook(trainingForBook)" class="rounded-md w-full text-gray-emb bg-green-emb mt-[10px] font-bold">Списати з поточного</button>
            <button v-else @click="addClientBook(trainingForBook)" class="rounded-md w-full text-gray-emb bg-green-emb mt-[10px] font-bold">Записатись</button>
            <!-- <button @click="addClientBook(trainingForBook)" class="rounded-md w-full text-gray-emb bg-green-emb mt-[10px] font-bold">Списати з поточного</button> -->
            <div v-if="currentTarriff?.tarrif_group_name != trainingForBook.tariff_group_name">
                <div 
                    v-if="
                        isTariffLowRank(currentTarriff?.tarrif_group_name, trainingForBook.tariff_group_name) && (trainingForBook.tariff_group_name == 'PERSONAL') ||
                        isTariffHighRank(currentTarriff?.tarrif_group_name, trainingForBook.tariff_group_name) && (trainingForBook.tariff_group_name == 'PERSONAL')
                    "
                    class="bg-rose-emb rounded-md text-center text-gray-emb px-[3px] font-bold w-full mt-[10px]"
                    @click="$router.push('/payment-view?tariffGroup=PERSONAL')"
                >Придбати абонемент</div>
                <div 
                    v-if="
                        isTariffLowRank(currentTarriff?.tarrif_group_name, trainingForBook.tariff_group_name) && (trainingForBook.tariff_group_name == 'SPLIT') ||
                        isTariffHighRank(currentTarriff?.tarrif_group_name, trainingForBook.tariff_group_name) && (trainingForBook.tariff_group_name == 'SPLIT')
                    "
                    class="bg-green-emb rounded-md text-center text-gray-emb px-[3px] font-bold w-full mt-[10px]" 
                    @click="$router.push('/payment-view?tariffGroup=SPLIT')"   
                >Придбати абонемент</div>
                <div 
                    v-if="
                        isTariffLowRank(currentTarriff?.tarrif_group_name, trainingForBook.tariff_group_name) && (trainingForBook.tariff_group_name == 'TEAM') ||
                        isTariffHighRank(currentTarriff?.tarrif_group_name, trainingForBook.tariff_group_name) && (trainingForBook.tariff_group_name == 'TEAM')
                    "
                    @click="$router.push('/payment-view?tariffGroup=TEAM')"   
                class="bg-violet-emb rounded-md text-center text-gray-emb px-[3px] w-full font-bold mt-[10px]">Придбати абонемент</div>
            </div>
            <button @click="() => { bookTrainingFlag = false; trainingForBook = null }" class="rounded-md w-full text-gray-emb bg-rose-emb mt-[10px] font-bold">Скасувати</button>
        </div>

        <div v-if="addBookErrorFlag" class="w-[80%] px-[20px] pb-[20px] bg-white rounded-md fixed top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] z-[999]">
            <div v-if="currentTarriff?.tarrif_group_name == trainingForBook.tariff_group_name" class="text-gray-emb font-bold text-[12px] text-center mt-[20px]">
                Кількість записів за наявним абонементом максимальна.
                <br><br>
                Щоб записатись на дане тренування, Ви можете придбати новий абонемент:
            </div>
            <!-- <button @click="addClientBook(trainingForBook)" class="rounded-md w-full text-gray-emb bg-green-emb mt-[10px] font-bold">Списати з поточного</button> -->
            <div>
                <div 
                    v-if="
                        trainingForBook.tariff_group_name == 'PERSONAL'
                    "
                    class="bg-rose-emb rounded-md text-center text-gray-emb px-[3px] font-bold w-full mt-[10px]"
                    @click="$router.push('/payment-view?tariffGroup=PERSONAL')"
                >Придбати абонемент</div>
                <div 
                    v-if="
                        trainingForBook.tariff_group_name == 'SPLIT'
                    "
                    class="bg-green-emb rounded-md text-center text-gray-emb px-[3px] font-bold w-full mt-[10px]" 
                    @click="$router.push('/payment-view?tariffGroup=SPLIT')"   
                >Придбати абонемент</div>
                <div 
                    v-if="
                        trainingForBook.tariff_group_name == 'TEAM'
                    "
                    @click="$router.push('/payment-view?tariffGroup=TEAM')"   
                class="bg-violet-emb rounded-md text-center text-gray-emb px-[3px] w-full font-bold mt-[10px]">Придбати абонемент</div>
            </div>
            <button @click="() => { addBookErrorFlag = false; }" class="rounded-md w-full text-gray-emb bg-rose-emb mt-[10px] font-bold">Скасувати</button>
        </div>

        <div v-if="cancelTrainingFlag" @click="() => { cancelTrainingFlag = false; cancelTraining = null }" class=" backdrop-blur-md fixed w-full z-[999] h-full"></div>
        <div v-if="cancelTrainingFlag" class="w-[80%] px-[20px] h-[140px] bg-white rounded-md fixed top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] z-[999]">
            <div class="text-gray-emb font-bold text-[12px] text-center mt-[20px]">Ви здійснюєте відміну запису на заняття {{ translateGroupName(cancelTraining.tariff_group_name) }}, {{ trainings[0]?.date.split('T')[0].split('-').reverse().join('.') }}, {{ cancelTraining.start_time }}</div>
            <button @click="deleteBook(cancelTraining)" class="rounded-md w-full text-gray-emb bg-green-emb mt-[10px] font-bold">Підтвердити</button>
            <button @click="() => { cancelTrainingFlag = false; cancelTraining = null }" class="rounded-md w-full text-gray-emb bg-rose-emb mt-[10px] font-bold">Скасувати</button>
        </div>

        <div v-if="cancelTrainingWithWriteoffFlag" @click="() => { cancelTrainingWithWriteoffFlag = false; cancelTrainingWithWriteoff = null }" class=" backdrop-blur-md fixed w-full z-[999] h-full"></div>
        <div v-if="cancelTrainingWithWriteoffFlag" class="w-[80%] px-[20px] pb-[20px] bg-white rounded-md fixed top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] z-[999]">
            <div class="text-gray-emb font-bold text-[12px] text-center mt-[20px]">Ви повідомляєте нас про те, що будете відсутні на тренуванні {{ translateGroupName(cancelTrainingWithWriteoff?.tariff_group_name) }}, {{ trainings[0]?.date.split('T')[0].split('-').reverse().join('.') }}, {{ cancelTrainingWithWriteoff?.start_time }}. Звертаємо увагу: скасування тепер (менш ніж за 6/12 годин до початку заняття) передбачає списання даного заняття з абонемента. Після скасування місце автоматично звільниться для інших клієнтів.</div>
            <button @click="deleteBookWithWriteoff(cancelTrainingWithWriteoff)" class="rounded-md w-full text-gray-emb bg-green-emb mt-[10px] font-bold">Все одно скасувати</button>
            <button @click="() => { cancelTrainingWithWriteoffFlag = false; cancelTrainingWithWriteoff = null }" class="rounded-md w-full text-gray-emb bg-rose-emb mt-[10px] font-bold">Залишити запис</button>
        </div>

        <div @click="$emit('close')" class="flex text-[#4A4E69] items-center ml-3 mt-2">
            <svg width="10" height="19" viewBox="0 0 10 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 17L1.56957 10.8258C0.810144 10.0966 0.810144 8.90341 1.56957 8.17424L8 2" stroke="#22223B" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="square" stroke-linejoin="round"/>
            </svg>
            <div class="ml-2 text-[#4A4E69]">
                Назад
            </div>
        </div>

        <div class="border-b-[1px] border-[#4A4E69] pb-2 text-gray-emb text-[20px] font-bold text-center w-[90%] mx-auto">
            {{ trainings[0]?.date.split('T')[0].split('-').reverse().join('.') }}
        </div>

        <div class="mt-[20px] h-[83%] overflow-y-auto">
            <div v-for="training in allTrainings" >
                <SquircleComponent 
                    :smooth="70" 
                    :radius="44" 
                    :width="354" 
                    :height="78" 
                    :outlineWidth="0"
                    class="flex items-center justify-center text-[#4A4E69] px-[10px] mx-auto mb-[10px]"
                    :class="{
                        'bg-[#E7F1F1] h-[76px] pt-[10px] rounded-[20px] ' : training?.isAttended,
                        'border-green-emb border-[4px] h-[76px] pt-[10px] rounded-[20px] ' : training?.isBooked,
                        'border-red-atten border-[4px] h-[76px] pt-[10px] rounded-[20px] ' : training?.isMissed,
                        'bg-transparent h-[76px] pt-[10px] rounded-[20px] border-transparent border-[2px]' : !training?.isBooked && !training?.isAttended,
                        'hidden' : training?.status === 'completed' && !training?.isAttended && !training?.isMissed
                    }"    
                    @click="emitTraining(training) "
                >
                    <div class="w-[52.1px] h-[44px] mr-[10px] relative bottom-[5px] rounded-full overflow-hidden border-[2px] border-[#525A60] ">
                        <img v-if="training?.trainer_photo" class="w-full h-full " :src="apiURL + 'static/' + training?.trainer_photo">
                        <div v-else class="h-full w-full flex justify-center items-center text-gray-emb bg-gray-emb bg-opacity-20 truncate">{{ training.trainer_label.split(' ')[0][0].toUpperCase() + training.trainer_label.split(' ')[1][0].toUpperCase() }}</div>
                    </div>
                    <div class="w-full mt-[px]">
                        <div class="w-full border-b-[0.2px] border-[#fff] border-opacity-20 pb-[10px]">
                            <div class="flex w-full">
                                <!-- <div class="font-bold relative text-[16px] text-gray-emb bottom-[5px] w-[37%] truncate">{{ training.trainer_label.split(' ')[0] + ' ' + training.trainer_label.split(' ')[1][0] + '.'  }}</div> -->
                                <div class="font-bold relative text-[16px] text-gray-emb bottom-[5px] ">{{ parseType(training.type)  }}</div>
                                <div class="font-bold text-[13px] relative text-gray-emb bottom-[1px] ml-[10px]">{{ training.tariff_group_name ? translateGroupName(training.tariff_group_name) : 'PER/SPLIT'  }}</div>
                            </div>
                            <div class="flex justify-start w-full">
                                <div class="flex w-[37%] relative top-[6px]">
                                    <div class="text-[11px] text-gray-emb">{{ training.start_time }}</div>
                                    <div class="mx-[5px] text-[11px] text-gray-emb">
                                        <svg class="scale-50 origin-center relative top-[1px]" width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M1 11L5.29289 6.70711C5.62623 6.37377 5.79289 6.20711 5.79289 6C5.79289 5.79289 5.62623 5.62623 5.29289 5.29289L1 1" stroke="#22223B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                        </svg>
                                    </div>
                                    <div class="text-[11px] text-gray-emb">{{ training.end_time }}</div>
                                </div>
                                <div class="text-start text-[11px] relative top-[6px] truncate">{{ training.trainer_label.split(' ')[0] + ' ' + training.trainer_label.split(' ')[1][0] + '.'  }} </div>
    
                                <div class="flex ml-auto mt-[-13px]">
                                    <div class="text-[11px] w-[55px] mt-[4px] text-gray-emb">
                                        <!-- {{training.location_label}} -->
                                    </div>
                                    <div 
                                        class="truncate text-[#6BA292] font-bold w-[30px] text-start"
                                        :class="{
                                            'text-[#6BA292]' : training.clientsCount < training.max_clients,
                                            'text-[#BF637D]' : training.clientsCount >= training.max_clients
                                        }"    
                                    >{{ training.clientsCount }}/{{ training.max_clients }}</div>
                                    <div 
                                        class="h-[22px] w-[22px] border-[2px] ml-[5px] rounded-full"
                                        :class="{
                                            'bg-[#6BA292] border-[#6BA292]' : training.clientsCount < training.max_clients,
                                            'bg-[#BF637D] border-[#BF637D]' : training.clientsCount >= training.max_clients
                                        }"
                                    ></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </SquircleComponent>
                <div v-if="!(currentTarrifDateExpire <= dateToTimestamp(training.date) && clientAvalaibelBooks > 0)" class="w-full flex justify-center">
                    <div class="w-full flex justify-center" v-if="(clientTarriffName == 'PERSONAL' && (training.tariff_group_name == 'PERSONAL' || training.tariff_group_name == 'SPLIT' || training.tariff_group_name == 'TEAM')) || (clientTarriffName == 'SPLIT' && (training.tariff_group_name == 'SPLIT' || training.tariff_group_name == 'TEAM')) || (clientTarriffName == 'TEAM' && training.tariff_group_name == 'TEAM')">
                        <button @click="() => { bookTrainingFlag = true; trainingForBook = training }" v-if="(training.clientsCount < training.max_clients) && !training?.isBooked && !(training?.isBooked && getTimeToStart(training) > 0)" class="bg-green-emb w-[90%] mx-auto rounded-md py-[5px] mb-[20px]">Записатись</button>
                        <button @click="() => { cancelTrainingWithWriteoffFlag = true; cancelTrainingWithWriteoff = training }" v-if="training?.isBooked && (!(getTimeToStart(training) > 0) || trainingCustomTime(training))" class="bg-rose-emb w-[90%] mx-auto rounded-md py-[5px] mb-[20px]">Мене не буде</button>
                        <button @click="() => { cancelTrainingFlag = true; cancelTraining = training }" v-if="training?.isBooked && getTimeToStart(training) > 0 && !trainingCustomTime(training)" class="bg-rose-emb w-[90%] mx-auto rounded-md py-[5px] mb-[20px]">Відмінити</button>
                        <button @click="addToWaitlist(training)" v-if="(training.clientsCount >= training.max_clients) && !training?.isBooked" class="bg-violet-emb w-[90%] mx-auto rounded-md py-[5px] mb-[20px]">Повідомити як звільниться місце</button> 
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { ref, onMounted, computed, watch } from 'vue'
    import { useRouter } from 'vue-router'
    import { useMainStore } from '@/mobileApp/store/mainStore'
    import SquircleComponent from '@/mobileApp/components/SquircleComponent.vue'
    import { deleteClientTrainingById, deleteClientTrainingWithTrainingWriteoff, addClientTrainingBook, addClientToWaitlist } from '@/mobileApp/services/apiRequests'

    export default {
        name: 'multi-training-viewer',

        props: {
            trainings: {
                type: Array,
                default: () => []
            },
            clientTarriffName: {
                type: String,
                default: ''
            },
            currentTarriffId: {
                type: Number,
                default: 0
            },
            currentTariffObject: {
                type: Object,
                default: () => ({})
            }
        },

        setup(props, { emit }) {
            const apiURL = ref('')
            const router = useRouter()
            const store = useMainStore()

            const emitTraining = (training) => {
                if (training.isBooked && !training.isAttended && !training.isMissed) {
                    emit('bookedTrainingShow', training)
                } 
                else if (training.clientsCount >= training.max_clients && !training.isBooked && !training.isAttended && !training.isMissed) {
                    emit('fullTrainingAlert', training)
                }
                else if (training.isAttended) {
                    emit('completedTrainingShow', [training])
                } else if (training.isMissed) {
                    emit('missedTrainingShow', [training])
                }
                else {
                    emit('planedTrainingShow', training)
                }
                // else {
                //     if (training.clientsCount >= training.max_clients) {
                //         emit('fullTrainingAlert', training)
                //     } else {
                //         emit('planedTrainingShow', training)
                //     }

                // }
            }

            const clientAvalaibelBooks = ref(0)
            const currentTarrifDateExpire = ref('')
            const currentTarriff = computed(() => {
                return store.clientTariffs[props.currentTarriffId]
            })
            onMounted(() => {
                console.log('11231')
                console.log(props.trainings)
                apiURL.value = process.env.VUE_APP_API_URL

                emit('updateTariffs')

                clientAvalaibelBooks.value = store.clientTariffs[props.currentTarriffId].tariff_training_count
                // currentTarrifDateExpire.value = store.clientTariffs[props.currentTarriffId].tariff_date_expire
                currentTarrifDateExpire.value = new Date(store.clientTariffs[props.currentTarriffId].date_expired).setHours(23, 59, 59, 999);

                console.log('clientAvalaibelBooks', clientAvalaibelBooks.value)
                console.log('currentTarrifDateExpire', currentTarrifDateExpire.value)
            })

            watch(() => store.clientTariffs[props.currentTarriffId], (newVal) => {
                clientAvalaibelBooks.value = newVal.tariff_training_count
                currentTarrifDateExpire.value = new Date(newVal.date_expired).setHours(23, 59, 59, 999);
            })

            const dateToTimestamp = (date) => {
                const dateParts = date.split('T')[0].split('-');
                const timeParts = date.split('T')[1].split(':');
                return new Date(dateParts[0], dateParts[1] - 1, dateParts[2], timeParts[0], timeParts[1]).getTime();
            }

            const allTrainings = computed(() => {
                let trainings = props.trainings.sort((a, b) => {
                    return a.start_time.localeCompare(b.start_time)
                })
                // if (props.clientTarriffName.toUpperCase() === 'TEAM') {
                //     trainings = trainings.filter((training) => {
                //         return training.superposition === false
                //     })
                // }
                return trainings
            })

            const parseType = (type) => {
                switch (type) {
                    case 'yoga':
                        return 'йога'
                    case 'barre':
                        return 'барре'
                    case 'pilates_ref':
                        return 'пілатес (реф.)'
                    case 'pilates_mat':
                        return 'пілатес (мат)'
                    case 'straching':
                        return 'стретчинг'
                    case 'pilates_preg':
                        return 'пілатес(вагітні)'
                    case 'bodysculpt':
                        return 'бодіскульпт'
                    case 'vinyasa_flow':
                        return 'вінʼяса флоу'
                    case 'hatha_yoga':
                        return 'хатха йога'
                    case 'fly_stretching':
                        return 'fly-стретчинг'
                    case 'bfb':
                        return 'BFB'
                }
            }

            const getTimeToStart = (training) => {
                let diff = 0

                if (training.tariff_group_name != 'TEAM') {
                    diff = new Date(training.date.split('T')[0] + 'T' + training.start_time + ':00').getTime() - new Date().getTime() - (12 * 60 * 60 * 1000);
                } else {
                    diff = new Date(training.date.split('T')[0] + 'T' + training.start_time + ':00').getTime() - new Date().getTime() - (6 * 60 * 60 * 1000);
                }
                return diff
            }

            const deleteBook = async (training) => {
                const response = await deleteClientTrainingById(training.training_id, store.student.student_id);
                router.go();
            }

            const deleteBookWithWriteoff = async (training) => {
                const response = await deleteClientTrainingWithTrainingWriteoff(training.training_id, store.student.student_id);
                router.go();
            }

            const addBookErrorFlag = ref(false)

            const addClientBook = async (training) => {
                let currentBookTarrif = null
                // loading.value = true;
                console.log('props.currentTarriffId', props.currentTarriffId);
                if (training.superposition) {
                    currentBookTarrif = store.clientTariffs[props.currentTarriffId]    
                } else {
                    // currentBookTarrif = store.clientTariffs.find(tariff => tariff.tarrif_group_id === training.tariff_group_id);
                    currentBookTarrif = store.clientTariffs[props.currentTarriffId]  
                }                

                if (!currentBookTarrif) {
                    // alert('Ви не можете записатись на це тренування, так як у вас немає підходящого абонементу');
                    // return;
                    currentBookTarrif = store.clientTariffs[props.currentTarriffId]
                }
                try {
                    const response = await addClientTrainingBook({
                        training_id: training.training_id,
                        client_id: store.student.student_id,
                        status: "planed",
                        date: training.date,
                        start_time: training.start_time,
                        end_time: training.end_time,
    
                        tariff_id: currentBookTarrif.tariff_id,
                        tariff_price: currentBookTarrif.tariff_price,
                        tariff_training_count: currentBookTarrif.tariff_training_count,
                        client_tariff_id: currentBookTarrif.client_tariff_id,
    
                        client_label: store.student.student_name + ' ' + store.student.student_surname,
                        client_photo: store.student.photo,
                        client_phone: store.student.phone,
                    });
                } catch (error) {
                    // alert('У вас недостатньо тренувань в абонементі, або ви не можете записатись на це тренування, так як у вас немає підходящого абонементу');
                    addBookErrorFlag.value = true;
                    return;
                }

                router.go();
            }

            const alertFreePlace = ref(false)
            const addToWaitlist = async (training) => {
                const response = await addClientToWaitlist(store.student.student_id, training.training_id);
                if (response.status === 200) {
                    alertFreePlace.value = true;
                }
            }

            const bookTrainingFlag = ref(false)
            const trainingForBook = ref(null)

            const cancelTrainingFlag = ref(false)
            const cancelTraining = ref(null)

            const cancelTrainingWithWriteoff = ref(null)
            const cancelTrainingWithWriteoffFlag = ref(false)

            const isTariffHighRank = (tariffGroupName, trainingGroupName) => {
                if (tariffGroupName === 'PERSONAL') {
                    if (trainingGroupName === 'PERSONAL' || trainingGroupName === 'SPLIT' || trainingGroupName === 'TEAM') {
                        return true
                    }
                } 

                if (tariffGroupName === 'SPLIT') {
                    if (trainingGroupName === 'SPLIT' || trainingGroupName === 'TEAM') {
                        return true
                    }
                }

                if (tariffGroupName === 'TEAM') {
                    if (trainingGroupName === 'TEAM') {
                        return true
                    }
                }
                return false
            }

            const isTariffLowRank = (tariffGroupName, trainingGroupName) => {
                if (tariffGroupName === 'PERSONAL') {
                    return false
                } 

                if (tariffGroupName === 'SPLIT') {
                    if (trainingGroupName === 'PERSONAL') {
                        return true
                    }
                }

                if (tariffGroupName === 'TEAM') {
                    if (trainingGroupName === 'SPLIT' || trainingGroupName === 'PERSONAL') {
                        return true
                    }
                }
                return true
            }

            const translateGroupName = (name) => {
                // Implement your translation logic here
                if (name === 'PERSONAL') {
                    return 'ІНДИВ';
                } else if (name === 'SPLIT') {
                    return 'ДУО';
                } else if (name === 'TEAM') {
                    return 'ГРУПОВЕ';
                } 
            }

            const trainingCustomTime = (training) => {
                console.log('trainingCustomTime', training.start_time)

                if (training.start_time == '08:00' || training.start_time == '08:30' || training.start_time == '09:00' || training.start_time == '09:30' || training.start_time == '10:00' || training.start_time == '10:30') {
                    const nowTime = new Date();
                    const trainingTime = new Date(training.date.split('T')[0] + 'T' + training.start_time + ':00');
                    const nowTimeMoreThan8PM = nowTime.getHours() >= 20;

                    console.log('nowTimeMoreThan8PM', nowTimeMoreThan8PM)
                    const ifTrainingTomorrow = trainingTime.getDate() > nowTime.getDate() || (trainingTime.getDate() === nowTime.getDate() && trainingTime.getMonth() > nowTime.getMonth());
                    if (nowTimeMoreThan8PM && ifTrainingTomorrow) {
                        return true;
                    } 
                }
                return false;
            }

            return {
                apiURL,
                emitTraining,
                parseType,
                allTrainings,
                getTimeToStart,
                deleteBook,
                deleteBookWithWriteoff,
                addClientBook,
                addToWaitlist,
                alertFreePlace,
                isTariffHighRank,
                isTariffLowRank,

                bookTrainingFlag,
                trainingForBook,

                cancelTrainingFlag,
                cancelTraining,

                cancelTrainingWithWriteoff,
                cancelTrainingWithWriteoffFlag,

                translateGroupName,
                clientAvalaibelBooks,
                currentTarrifDateExpire,
                dateToTimestamp,
                currentTarriff,
                addBookErrorFlag,
                trainingCustomTime
            }
        },

        components: {
            SquircleComponent
        }
    }
</script>

<style lang="scss" scoped>

</style>